export default "__VITE_ASSET__4f139f02__"